import { Skeleton } from 'primereact/skeleton';
import classes from './constrainedForecast.module.scss';

const ConstrainedForecastLoadingSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="45rem"></Skeleton>
      </div>
    </div>
  );
};

export default ConstrainedForecastLoadingSkeleton;
